export default __webpack_public_path__ + "static/media/frame_top.4472f615.png";